import { Button, Grid, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import ReactPhoneInput from 'react-phone-input-material-ui';
import WushTextField from "../../../../form/WushTextField";
import useCheckoutStore from "../../../../../stores/public/useCheckoutStore";
import update from "../../../../../api/public/storePages/customers/update";
import updateReservation from "../../../../../api/public/storePages/reservations/update";

import create from "../../../../../api/public/storePages/customers/create";
import useYupValidationResolver from "../../../../../services/useYupValidationResolver";

import * as yup from 'yup';
import ReservationQuestionAnswers from "../../../../form/reservation/ReservationQuestionAnswers";

const validationSchema = yup.object({
  first_name: yup.string().required("Required"),
  last_name: yup.string().required("Required"),
  email: yup.string().email("Invalid email").required("Required")
});

export default function CustomerInformationForm({nextStep, previousStep}) {
  const resolver = useYupValidationResolver(validationSchema);
  const { customer, setCustomer, storePage, reservation } = useCheckoutStore();
  const { register, handleSubmit, setValue, formState } = useForm({
    resolver: resolver,
    defaultValues: customer,
    reValidateMode: 'onSubmit'
  });

  const onSubmit = (values) => {
    if(customer?.id) {
      update(storePage.id, customer.id, values, (response) => {
        updateReservation(storePage.id, reservation.id, {
          customer_id: response.id
        }, (response) => {
          console.log(response);
        });
        setCustomer(response);
      });
    } else {
      create(storePage.id, values, (response) => {
        updateReservation(storePage.id, reservation.id, {
          customer_id: response.id
        }, (response) => {
          console.log(response);
        });
        setCustomer(response);
      });
    }
    nextStep();
  };

  return (
    <Stack px={4} gap={3} py={2}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap={1} mb={1}>
          <Grid container spacing={2}>
            <Grid item sm={6}>
              <Stack>
                <WushTextField formRegistration={register('first_name')} formState={formState} label="First Name" defaultValue={customer?.first_name} />
              </Stack>
            </Grid>
            <Grid item sm={6}>
              <Stack>
                <WushTextField formRegistration={register('last_name')} formState={formState} label="Last Name" defaultValue={customer?.last_name} />
              </Stack>
            </Grid>
            <Grid item sm={6}>
              <Stack>
                <ReactPhoneInput
                  onChange={(phone) => setValue('phone', phone) }
                  defaultCountry={'us'}
                  component={WushTextField}
                  inputProps={{
                    formState: formState,
                  }}
                />
              </Stack>
            </Grid>
            <Grid item sm={6}>
              <Stack>
                <WushTextField formRegistration={register('email')} formState={formState} label="Email" defaultValue={customer?.email} />
              </Stack>
            </Grid>
          </Grid>
          <ReservationQuestionAnswers reservation={reservation} />
        </Stack>
        <Stack direction="row" width="100%" justifyContent="center">
          <Button onClick={previousStep}>Back</Button>
          <Button variant="contained" onClick={handleSubmit(onSubmit)}>Next</Button>
        </Stack>
      </form>
    </Stack>
  );
}